'use client';
import { type Cart } from '@shopify/hydrogen-react/storefront-api-types';
import { atom } from 'jotai';

export const cartAtom = atom<Cart | undefined>(undefined);
